import React, { createContext, useState, useEffect } from 'react';
import frTranslations from '../locales/fr.json';
import enTranslations from '../locales/en.json';

export const LanguageContext = createContext();

const translations = {
  fr: frTranslations,
  en: enTranslations
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguageState] = useState('fr');

  // Initialize language from localStorage, then domain, then browser
  useEffect(() => {
    const stored = localStorage.getItem('preferredLanguage');
    if (stored && ['fr', 'en'].includes(stored)) {
      // Respect the user's explicit choice above everything
      setLanguageState(stored);
      return;
    }

    // No saved preference — infer from domain first
    const hostname = window.location.hostname;
    let detectedLang;
    if (hostname.endsWith('.fr')) {
      detectedLang = 'fr';
    } else if (hostname.endsWith('.com')) {
      detectedLang = 'en';
    } else {
      // localhost / other — fall back to browser language
      const browserLang = navigator.language.split('-')[0];
      detectedLang = ['fr', 'en'].includes(browserLang) ? browserLang : 'fr';
    }

    setLanguageState(detectedLang);
    localStorage.setItem('preferredLanguage', detectedLang);
  }, []);

  // Translation function with dot notation support
  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];

    for (const k of keys) {
      value = value?.[k];
      if (value === undefined) {
        console.warn(`Translation missing for key: ${key} (language: ${language})`);
        return key;
      }
    }

    return value;
  };

  // Change language and persist to localStorage
  const setLanguage = (newLang) => {
    if (['fr', 'en'].includes(newLang)) {
      setLanguageState(newLang);
      localStorage.setItem('preferredLanguage', newLang);
    }
  };

  const value = {
    language,
    setLanguage,
    t
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};
